import { gql } from '@apollo/client';

export const GET_UPCOMING_MATCH_WEEK = gql`
  query GetUpcomingMatchWeek {
    getUpcomingMatchWeek {
      id
      startDate
      weekNumber
    }
  }
`;
